// eslint-disable-next-line import/no-webpack-loader-syntax
export const mainTheme = require('sass-extract-loader?{"plugins":["sass-extract-js"]}!./variables.scss');
